package com.havn.app.core.localization

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.staticCompositionLocalOf

val LocalHavnLanguage = staticCompositionLocalOf { HavnLanguage.English }
val LocalHavnStrings = staticCompositionLocalOf { HavnStringCatalog.stringsFor(HavnLanguage.English) }

@Composable
fun HavnLocalizationProvider(
    language: HavnLanguage,
    content: @Composable () -> Unit
) {
    CompositionLocalProvider(
        LocalHavnLanguage provides language,
        LocalHavnStrings provides HavnStringCatalog.stringsFor(language),
        content = content
    )
}
